module.exports = __webpack_public_path__ + "static/media/pierre-3.3f8816c8.jpeg";